import type { IExtensionResponse } from '@/openapi-clients-generated/talk';

export function formatExtension(extension?: Pick<IExtensionResponse, 'extension' | 'name' | 'displayName'>) {
    if (!extension) return '';
    return `${extension.extension} ${extension.displayName || extension.name}`.trim();
}
